import React from "react";

import "./running.scss";

const RunningIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="system--running">
    <rect id="Margin" className="st0" width="24" height="24" />
    <g id="uuid-005c1510-c70d-41ca-a250-49840c437040">
      <path
        id="uuid-6a7e1733-f219-486e-969e-d273681d9c22"
        className="st1"
        d="M12,22.9C6,22.9,1.1,18,1.1,12S6,1.1,12,1.1S22.9,6,22.9,12
		S18,22.9,12,22.9L12,22.9z"
      />
      <path
        id="uuid-976b56b3-c46f-4d08-a34f-a7c23ef207de"
        className="st2"
        d="M12,2.2c-5.4,0-9.8,4.4-9.8,9.8s4.4,9.8,9.8,9.8
		s9.8-4.4,9.8-9.8S17.4,2.2,12,2.2 M12,0c6.6,0,12,5.4,12,12s-5.4,12-12,12S0,18.6,0,12S5.4,0,12,0z"
      />
    </g>
    <path
      id="uuid-649f392d-fc85-46f5-a8c9-f70b27cd9abd"
      className="st2"
      d="M7.1,12.6l1.1-1.1l2.2,2.1l5.4-5.4l1.1,1.1l-6.6,6.6
	C10.4,15.9,7.1,12.6,7.1,12.6z"
    />
  </svg>
);

export default RunningIcon;
